import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgSendMe = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M14.509 15H3.49q-.696 0-1.093-.294Q2 14.419 2 13.9q0-.735.48-1.564.49-.828 1.4-1.54.92-.72 2.212-1.17 1.293-.457 2.9-.457 1.616 0 2.907.457 1.293.45 2.204 1.17.92.711 1.408 1.54.489.83.489 1.564 0 .52-.398.806-.398.294-1.093.294m-3.844-7.658A3.2 3.2 0 0 1 9 7.799a3.2 3.2 0 0 1-1.665-.457A3.55 3.55 0 0 1 6.117 6.11a3.37 3.37 0 0 1-.455-1.743q0-.944.455-1.703.464-.766 1.226-1.216T9 1q.903 0 1.665.441.762.442 1.218 1.208a3.2 3.2 0 0 1 .464 1.704 3.4 3.4 0 0 1-.464 1.758q-.456.774-1.218 1.23m-8.882.793L0 8.15V6.884l1.79-.029.012-1.421a.4.4 0 0 1 .103-.307.42.42 0 0 1 .272-.125q.164-.015.337.09l3.26 1.98q.15.09.2.25a.5.5 0 0 1 .002.315.44.44 0 0 1-.201.252l-3.29 2.016a.56.56 0 0 1-.339.094.4.4 0 0 1-.27-.122q-.106-.11-.105-.31z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSendMe);
export default ForwardRef;
